export default "__VITE_ASSET__Ce3Es_lx__"